module.exports = __webpack_public_path__ + "img/rp-logo.197c7f98.png";